import { FC, ReactElement, useContext } from "react";
import { useMobile } from "../../hooks/useMobile";
import {
  QuizContext,
  TextConfig,
} from "../../providers/QuizProvider/QuizContext";
import { ButtonType1 } from "./ButtonTypes/ButtonType1";
import { ButtonType2 } from "./ButtonTypes/ButtonType2";
import { ButtonType3 } from "./ButtonTypes/ButtonType3";
import { ButtonType4 } from "./ButtonTypes/ButtonType4";
import { ButtonType5 } from "./ButtonTypes/ButtonType5";
import { ButtonType6 } from "./ButtonTypes/ButtonType6";
import { ButtonType7 } from "./ButtonTypes/ButtonType7";
import { ButtonType8 } from "./ButtonTypes/ButtonType8";
import { ButtonType9 } from "./ButtonTypes/ButtonType9";
import { useTranslation } from "../../hooks/useTranslation";

const ButtonTypesComponent: {
  [key: number]: (props: InnerProps) => ReactElement;
} = {
  1: (props) => <ButtonType1 {...props} />,
  2: (props) => <ButtonType2 {...props} />,
  3: (props) => <ButtonType3 {...props} />,
  4: (props) => <ButtonType4 {...props} />,
  5: (props) => <ButtonType5 {...props} />,
  6: (props) => <ButtonType6 {...props} />,
  7: (props) => <ButtonType7 {...props} />,
  8: (props) => <ButtonType8 {...props} />,
  9: (props) => <ButtonType9 {...props} />,
};

type InnerProps = {
  isHideArrow: boolean;
  title: string | null;
  isShowBack: boolean;
  titleConfig: TextConfig;
  onNext?: () => void;
  onPrev?: () => void;
  isDisabled?: boolean;
};

type Props = {
  isHideArrow?: boolean;
  title?: string;
  //type?: number;
  isShowBack?: boolean;
  titleConfig?: TextConfig;
  onNext?: () => void;
  onPrev?: () => void;
  isDisabled?: boolean;
};

export const Button: FC<Props> = ({
  //type,
  isHideArrow = false,
  title, // = "Далее",
  isShowBack = false,
  titleConfig,
  onNext,
  onPrev,
  isDisabled
}) => {
  const { t } = useTranslation();
  const quiz = useContext(QuizContext);
  const innerType = /* type ?? */ quiz.button_style;
  const isMobile = useMobile();
  const innerTitle = title ?? (isMobile ? null : t("nextBtn"));
  const innerTitleConfig = titleConfig ?? {
    bold: false,
    italic: false,
    underline: false,
  };

  return ButtonTypesComponent[innerType]
    ? ButtonTypesComponent[innerType]({
        isHideArrow,
        title: innerTitle,
        isShowBack,
        titleConfig: innerTitleConfig,
        onNext,
        onPrev,
        isDisabled
      })
    : ButtonTypesComponent[1]({
        isHideArrow,
        title: innerTitle,
        isShowBack,
        titleConfig: innerTitleConfig,
        onNext,
        onPrev,
        isDisabled
      });
};
